module.exports = __webpack_public_path__ + "static/media/Icon-awesome-paper-plane.eb79d075.svg";